export default "__VITE_ASSET__DgwwZNtj__"